import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../../../components/Modal/Modal";
import Button, { ButtonType } from "../../../../components/Button/Button";
import { Wrapper } from "../../../../components/styled/styled-components";
import { Address, OrderSplitCurrentOrder } from "../../../../interfaces/interfaces";
import AirbagError from "./AirbagError/AirbagError";
import OrderResult from "./OrderResult/OrderResult";
import OrderSplitModal from "./OrderSplitModal/OrderSplitModal";
import PickupNotice from "./PickupNotice/PickupNotice";
import TimedoutModal from "./TimedOutModal/TimedOutModal";
import { OrderSubmitStatuses } from "../../../../interfaces/enums";
import BankTransferInfoModal from "../../../../components/PaymentInfo/BankTransferInfoModal";
import { useNavigate } from "react-router-dom";
import EmailTransferInfoModal from "../../../../components/PaymentInfo/EmailTrasnferInfoModal";

interface Props {
  modalToShow: number;
  splitItemNumbers: string[];
  currentOrderShipAddress: Address;
  showSyd: boolean;
  showMel: boolean;
  showPer: boolean;
  showAuk: boolean;
  showCan: boolean;
  orderAccpacNumber: string | null;
  orderId: number;
  order: OrderSplitCurrentOrder | null;
  airbagErrorMessage: string | null;
  submitStatus: OrderSubmitStatuses | null;
  callSplitService: () => void;
  showRecalculateButton: boolean;
  setShowRecalculateButton: () => void;
  submitOrder: () => void;
  orderSubmitLoading: boolean;
  setModalToShow: React.Dispatch<React.SetStateAction<number>>;
}

const ModalSwitcher = ({
  modalToShow,
  splitItemNumbers,
  currentOrderShipAddress,
  showSyd,
  showMel,
  showPer,
  showAuk,
  showCan,
  orderAccpacNumber,
  orderId,
  order,
  submitStatus,
  callSplitService,
  airbagErrorMessage,
  showRecalculateButton,
  setShowRecalculateButton,
  submitOrder,
  orderSubmitLoading,
  setModalToShow,
}: Props) => {
  const GetModal = () => {
    const navigate = useNavigate();

    switch (modalToShow) {
      case 0:
        return (
          <OrderResult
            orderAccpacNumber={orderAccpacNumber}
            order={order}
            orderId={orderId}
            submitStatus={submitStatus}
            showSyd={showSyd}
            showMel={showMel}
            showPer={showPer}
            showAuk={showAuk}
            showCan={showCan}
            changeModalToShow={(modalToShow) => setModalToShow(modalToShow)}
          />
        );
      case 1:
        return (
          <AirbagError
            callSplitService={callSplitService}
            errorMessage={airbagErrorMessage}
            showRecalculateButton={showRecalculateButton}
            setShowRecalculateButton={setShowRecalculateButton}
          />
        );
      case 2:
        return (
          <TimedoutModal
            callSplitService={callSplitService}
            hideModal={() => {
              setModalToShow(-1);
            }}
          />
        );
      case 3:
        return (
          <PickupNotice
            state={currentOrderShipAddress?.state}
            showSyd={showSyd}
            showMel={showMel}
            showPer={showPer}
          />
        );
      case 4:
        return (
          <OrderSplitModal
            items={splitItemNumbers}
            hideModal={() => setModalToShow(-1)}
            currentOrderShipAddress={currentOrderShipAddress}
            pickup
          />
        );
      case 5:
        return (
          <OrderSplitModal
            items={splitItemNumbers}
            hideModal={() => setModalToShow(-1)}
            currentOrderShipAddress={currentOrderShipAddress}
          />
        );
      case 6:
        return (
          <Modal>
            <div className="modal-template">
              <h5>Are you sure you want to submit this order?</h5>
              {orderSubmitLoading ? (
                <Wrapper>
                  <LoadingSpinner />
                </Wrapper>
              ) : (
                <div className="modal-actions">
                  <Button type={ButtonType.secondary} onClick={() => setModalToShow(-1)}>
                    No
                  </Button>
                  <Button type={ButtonType.primary} onClick={() => submitOrder()}>
                    Yes
                  </Button>
                </div>
              )}
            </div>
          </Modal>
        );
      case 7:
        return (
          <BankTransferInfoModal
            onCloseModal={() => (window.location.href = "/order-history")}
            closeButtonName="Order Details"
          />
        );
      case 8:
        return (
          <EmailTransferInfoModal
            onCloseModal={() => navigate("/order-history")}
            closeButtonName="Order Details"
          />
        );

      default:
        return <></>;
    }
  };

  return GetModal();
};

export default ModalSwitcher;
